import { httpClient } from '../../network/httpclient/HttpClientFactory';

const list = areaType => httpClient.get(`/billboard/${areaType}`).then(res => res.data);
const save = (areaType, list) => httpClient.post(`/billboard/${areaType}`, list).then(res => res.data);

export default {
    list,
    save
};
